import { ParentProps, createContext, onMount } from 'solid-js'
import { requireContext } from 'common'
import { dataStore as api } from 'st-app/api'
import { DataStoreContext } from './DataStoreContext'
import styles from './st-data-store.module.css'

export { DataStoreContext }

const DataStoreContextJsx = createContext<DataStoreContext>();
export const requireDataStoreContext = () => {
    return requireContext(DataStoreContextJsx);
}


/** DataStore properties:
 * dataSource/primaryObject indicates the source object for loading all data. Only one should be used, and it can be a guid or qualified name
 **/
export class DataStoreProps {
    dataSource?: string;
    primaryObject?: string;
    context?: DataStoreContext;
}

export default function DataStore(props: ParentProps<DataStoreProps>) {
    const context = props.context ?? new DataStoreContext(props.dataSource, props.primaryObject);

    return (
        <DataStoreContextJsx.Provider value={context}>
            {props.children}
        </DataStoreContextJsx.Provider>
    )
}

DataStore.defaultProps = new DataStoreProps();